// 获取特色产品列表
import { defaultLocale } from "@/config";
import {
	ProductListByCategoryDocument,
	ProductListByCategoryPaginatedDocument,
	ProductListByCollectionDocument,
	ProductListByIdsDocument,
	ProductListPaginatedDocument,
  SearchProductsDocument,
  ProductCategoriesListDocument,
} from "@/gql/graphql";
import { executeGraphQL } from "@/lib/utils/graphql";
import { handleGraphqlLocale } from "@/lib/utils/util";

// 获取特色产品
export const getFeaturedProducts = async (locale: string, channel: string) => {
	const data = await executeGraphQL(ProductListByCategoryDocument, {
		variables: {
			slug: "featured-products",
			channel: channel,
			locale: handleGraphqlLocale(locale),
		},
		revalidate: 60,
	});
};

export const fetchProductData = async ({ locale,channel="default-channel", after = "" }) => {
//   console.log(locale, channel,'locale, channel');
  
	return await executeGraphQL(ProductListPaginatedDocument, {
		withAuth: false,
		variables: {
			first: 6,
			after,
			locale: handleGraphqlLocale(locale || defaultLocale),
			channel: channel,
		},
		revalidate: 300,
	});
};
// 2
export const fetchProductSearchData = async ({ 
  locale, 
  channel = "default-channel", // 默认频道
  searchQuery, 
  page = 1,
  limit = 9,
  sortBy = "NAME" as any,
  sortDirection = "ASC" as any
}) => {
	// 使用 Saleor 原生的 Search 过滤，它对多语言支持更好
	return await executeGraphQL(SearchProductsDocument, {
		withAuth: false,
		variables: {
			search: searchQuery.trim(),
			first: limit,
			// 这里根据页码计算分页逻辑，Saleor 通常使用 cursor 分页，如果是 page 分页需要对应处理
			channel,
			locale: handleGraphqlLocale(locale || defaultLocale),
			sortBy,
			sortDirection
		},
		revalidate: 60,
	});
};
export const fetchProductByCategoryData = async ({ slug, locale, channel, after = "", first = 9 }) => {
	return await executeGraphQL(ProductListByCategoryPaginatedDocument, {
		withAuth: false,
		variables: {
			slug,
			first,
			after,
			locale: handleGraphqlLocale(locale || defaultLocale),
			channel: channel,
		},
		revalidate: 60,
	});
};

// 搜索产品  返回产品id
export const searchProducts = async ({
	searchValue,
	page,
	limit,
	locale,
	langcode,
}: {
	page: string;
	limit: string;
	searchValue: string;
	locale?: string;
	langcode?: string | string[];
}) => {
	try {
		// 对搜索值进行 URL 编码
		const encodedSearchValue = encodeURIComponent(searchValue);
		const currentLocale = locale || defaultLocale;
		
		// 处理 langcode 参数：如果是数组，转换为逗号分隔的字符串；如果是字符串，直接使用
		let langcodeParam = langcode;
		if (Array.isArray(langcode)) {
			langcodeParam = langcode.join(',');
		} else if (!langcode) {
			// 如果没有提供 langcode，使用 locale 作为默认值
			langcodeParam = currentLocale;
		}
		
		// 尝试同时传递 lang 和 lang_code，并使用原始 locale 避免过度简化导致匹配失败
		const baseUrl = `${process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL}/saleor/product/${encodedSearchValue}?page=${page}&limit=${limit}&langcode=${encodeURIComponent(langcodeParam as string)}`;
		
		const app_token = process.env.NEXT_PUBLIC_SALEOR_APP_TOKEN;

		const res = await fetch(baseUrl, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${app_token}`,
			},
			next: { revalidate: 600 },
		});
		
		if (!res.ok) {
			console.error(`Product search failed with status: ${res.status}`);
		}
		
		const data = await res.json() as any;
		return data;
	} catch (error) {
		console.error("Error searching products:", error);
		throw error;
	}
};

// 根据id查产品
export const fetchSearchProductsData = async ({ ids, locale, channel }) => {
	return await executeGraphQL(ProductListByIdsDocument, {
		withAuth: false,
		variables: {
			first: 9,
			locale: handleGraphqlLocale(locale || defaultLocale),
			ids,
			channel: channel,
		},
		revalidate: 60,
	});
};

 
//收藏数据
export const getCollectionProducts = async ({ slug, locale, channel }) => {
	return await executeGraphQL(ProductListByCollectionDocument, {
		variables: {
			slug,
			channel: channel,
			locale: handleGraphqlLocale(locale),
		},
		revalidate: 60,
	});
};

// 获取分类列表
export const fetchCategoriesData = async ({ locale, channel, first = 100 }) => {
	return await executeGraphQL(ProductCategoriesListDocument, {
		withAuth: false,
		variables: {
			locale: handleGraphqlLocale(locale || defaultLocale),
			channel: channel,
			first,
		},
		revalidate: 300,
	});
};
